import { render, staticRenderFns } from "./herderList2.vue?vue&type=template&id=16606768&scoped=true"
import script from "./herderList2.vue?vue&type=script&lang=js"
export * from "./herderList2.vue?vue&type=script&lang=js"
import style0 from "./herderList2.vue?vue&type=style&index=0&id=16606768&prod&lang=scss&scoped=true"
import style1 from "./herderList2.vue?vue&type=style&index=1&id=16606768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16606768",
  null
  
)

export default component.exports